export function segmentWidth(participant, totalRegisteredDistance) {
  if (!totalRegisteredDistance) return 0;
  
  return `${(participant.distanceRegister / totalRegisteredDistance) * 100}%`;
}

export function progressWidth(participant) {
  return `${Math.min(participant.progressRatio, 1) * 100}%`;
}

export default function RelayRoute({ relay }) {
  return (
    <section className="relay-route-card htv-card">
      <div className="relay-route-heading">
        <div>
          <p className="htv-muted">Phân đoạn tiếp sức</p>
          <h2>Đội hình theo thứ tự đăng ký</h2>
        </div>
        <strong>{relay.participants?.length} người</strong>
      </div>

      <div
        className="relay-route"
        aria-label={`Hành trình từ ${relay.startLocation} đến ${relay.endLocation}`}
      >
        <div className="relay-route-labels">
          <strong>{relay.startLocation}</strong>
          <span>{Math.round(relay.progressRatio * 100)}%</span>
          <strong>{relay.endLocation}</strong>
        </div>
        <div className="relay-track">
          {relay.participants?.map((participant, i) => (
            <div
              className={`relay-segment relay-segment-${participant.status}`}
              style={{ width: segmentWidth(participant, relay.totalDistance) }}
              key={participant.userId}
              title={`${participant.name}: ${participant.totalDistance}/${participant.distanceRegister} km`}
            >
              <span style={{ width: progressWidth(participant) }} >{i + 1}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="relay-participant-strip">
        {relay.participants?.map((participant, i) => (
          <span key={participant.userId}>
            {i + 1}. {participant.name} · {participant.distanceRegister} km
          </span>
        ))}
      </div>
    </section>
  );
}
